import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/views/Home'], resolve)
const ScrollText = resolve => require(['@/views/ScrollText'], resolve)
const ScrollTextFull = resolve => require(['@/views/ScrollTextFull'], resolve)
const LedScreen = resolve => require(['@/views/LedScreen'], resolve)
const Relationship = resolve => require(['@/views/Relationship'], resolve)
const WasteClassification = resolve => require(['@/views/WasteClassification'], resolve)
const Reflex = resolve => require(['@/views/Reflex'], resolve)
const SchulteGrid = resolve => require(['@/views/SchulteGrid'], resolve)
const Property = resolve => require(['@/views/Property'], resolve)
const WhatToEat = resolve => require(['@/views/WhatToEat'], resolve)
const Ruler = resolve => require(['@/views/Ruler'], resolve)
const Protractor = resolve => require(['@/views/Protractor'], resolve)
const IdCard = resolve => require(['@/views/IdCard'], resolve)
const IdCardMake = resolve => require(['@/views/IdCardMake'], resolve)
const FeatureEmail = resolve => require(['@/views/FeatureEmail'], resolve)
const SizeCompare = resolve => require(['@/views/SizeCompare'], resolve)
const FlashScreen = resolve => require(['@/views/FlashScreen'], resolve)
const Decision = resolve => require(['@/views/Decision'], resolve)
const DecisionDetail = resolve => require(['@/views/DecisionDetail'], resolve)
const DecisionEdit = resolve => require(['@/views/DecisionEdit'], resolve)
const Name = resolve => require(['@/views/Name'], resolve)
const Email = resolve => require(['@/views/Email'], resolve)
const Aa = resolve => require(['@/views/Aa'], resolve)
const Who = resolve => require(['@/views/Who'], resolve)
const Turntable = resolve => require(['@/views/Turntable'], resolve)
const Award = resolve => require(['@/views/Award'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    {
        path: '/',
        component: Home
    },
    { path: '/tool/sound', component: resolve => require(['@/views/ToolSound'], resolve) },
    { path: '/tool/balance', component: resolve => require(['@/views/ToolBalance'], resolve) },
    { path: '/tool/compass', component: resolve => require(['@/views/ToolCompass'], resolve) },
    { path: '/idCard/crack', component: resolve => require(['@/views/IdCardCrack'], resolve) },
    { path: '/majiang', component: resolve => require(['@/views/Majiang'], resolve) },
    { path: '/openUrls', component: resolve => require(['@/views/OpenUrls'], resolve) },
    { path: '/pages', component: resolve => require(['@/views/Pages'], resolve) },
    { path: '/danmu', component: resolve => require(['@/views/Danmu'], resolve) },
    { path: '/avatar/weapp', component: resolve => require(['@/views/AvatarWeapp'], resolve) },
    {
        path: '/turntable',
        component: Turntable
    },
    {
        path: '/award',
        component: Award
    },
    {
        path: '/who',
        component: Who
    },
    {
        path: '/scroll_text',
        component: ScrollText
    },
    {
        path: '/aa',
        component: Aa
    },
    {
        path: '/name',
        component: Name
    },
    {
        path: '/email',
        component: Email
    },
    {
        path: '/id_card',
        component: IdCard
    },
    {
        path: '/idCard/make',
        component: IdCardMake
    },
    {
        path: '/waste_classification',
        component: WasteClassification
    },
    {
        path: '/led_screen',
        component: LedScreen
    },
    {
        path: '/relationship',
        component: Relationship
    },
    {
        path: '/scroll_text',
        component: ScrollText
    },
    {
        path: '/scroll_text_full',
        component: ScrollTextFull
    },
    {
        path: '/reflex',
        component: Reflex
    },
    {
        path: '/schulte_grid',
        component: SchulteGrid
    },
    {
        path: '/property',
        component: Property
    },
    {
        path: '/what_to_eat',
        component: WhatToEat
    },
    {
        path: '/ruler',
        component: Ruler
    },
    {
        path: '/protractor',
        component: Protractor
    },
    { path: '/protractor/phone', component: resolve => require(['@/views/ProtractorPhone'], resolve) },
    {
        path: '/featureEmail',
        component: FeatureEmail
    },
    {
        path: '/sizeCompare',
        component: SizeCompare
    },
    {
        path: '/flashScreen',
        component: FlashScreen
    },
    {
        path: '/decision',
        component: Decision
    },
    {
        path: '/decisions/:id',
        component: DecisionDetail
    },
    {
        path: '/decisions/:id/edit',
        component: DecisionEdit
    },
    {
        path: '/decision/add',
        component: DecisionEdit
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js